import { useCallback } from 'react';
import { setWatchParamsMutation } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useLogger } from '@/shared/hooks/useLogger';
import { useGraphqlClient } from '@/shared/hooks/useGraphqlClient';

interface SetWatchParamsInput {
    audioLanguage: string;
    subtitleLanguage: string | null;
    contentId: string;
}

export const useSetWatchParams = () => {
    const logger = useLogger();
    const graphqlClient = useGraphqlClient();

    return useCallback(
        async ({ audioLanguage, subtitleLanguage, contentId }: SetWatchParamsInput) => {
            try {
                await graphqlClient.fetch({
                    operation: setWatchParamsMutation,
                    variables: {
                        input: {
                            audioLanguage,
                            subtitleLanguage,
                            contentId,
                        },
                    },
                });
            } catch (error) {
                logger.error({ error }, 'Failed to set watch params');
            }
        },
        [graphqlClient, logger]
    );
};
